import buttonStyles from "../../../atoms/Button/Button.module.css";
import classNames from "classnames";
import styles from "../ContentBlocks.module.css";
import { getAssetPath } from "utils";

export interface SmallPromoBlockModelProps {
  className?: string;

  Type?: string;
  Heading?: string;
  BlockURLText?: string;
  PromoImage?: { Alt?: string; Src: string };
  AssociatedWith: { Text: string; Url: string };
  LeafStyle?: boolean;
}

export const SmallPromoBlockModel = ({
  className = "",
  ...props
}: SmallPromoBlockModelProps) => {
  return (
    <a
      href={props.AssociatedWith.Url}
      className={classNames(
        styles.SmallPromoBlock,
        "animateonscroll",
        className,
        'SmallPromoBlockModel'
      )}
    >
      {props.PromoImage && (
        <div
          className={classNames(
            styles.promoImage,
            props.LeafStyle && styles.leafstyle
          )}
        >
          <img
            src={getAssetPath(props.PromoImage.Src)}
            alt={props.PromoImage.Alt}
          />
        </div>
      )}

      <div className={styles.promotext}>
        {props.Heading && <h3>{props.Heading}</h3>}
        {(props.BlockURLText || props.AssociatedWith.Text) && (
          <span className={classNames(buttonStyles.chevron, styles.chevron)}>
            {props.BlockURLText || props.AssociatedWith.Text}

            <svg
              style={{ top: '-1px' }}
              width="6"
              height="9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5.75 5.25 4.5 1.5 8.25"
                stroke="#84BD00"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        )}
      </div>
    </a>
  );
};
